import React, { useId } from 'react';

import { Select } from '@src/components/ui';

import FieldShell from './FieldShell';


/**
 * Base select field — label above, native select, helper/error line below.
 * Receives RHF field props (value/onChange/onBlur/name/ref) plus
 * `error` (bool) and `helperText` from the generic form wrapper. Pass
 * `options` as `[{ value, label }]` to render `<option>`s, or pass
 * `<option>`s as `children` directly (used when `options` is omitted).
 */
const SelectField = React.forwardRef((props, ref) => {
  const {
    label,
    value = '',
    error = false,
    suggested = false,
    helperText = ' ',
    className,
    options = null,
    children,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  const content = options
    ? options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))
    : children;

  return (
    <FieldShell
      id={id}
      label={label}
      className={className}
      suggested={suggested}
      helperText={helperText}
      error={error}
    >
      <Select ref={ref} id={id} value={value} invalid={error} {...restProps}>
        {content}
      </Select>
    </FieldShell>
  );
});

SelectField.displayName = 'SelectField';
export default SelectField;
